import TrackProAPI from './track-pro-api'
import {
    DownloadParamsType,
    EditPartType,
    NonEscoPartParamsType,
    UpdateAssetDataType,
} from '../types/bucketTypes'

const getAssetList = () => {
    return TrackProAPI.get('/assets')
}

const getSingleAsset = (assetId: string) => {
    const endpoint = `/assets/get?asset_id=${assetId}`
    return TrackProAPI.get(endpoint)
}

const updateAsset = (assetData: UpdateAssetDataType) => {
    return TrackProAPI.post('/assets/update', assetData)
}

const addNonEscoPart = (partData: NonEscoPartParamsType) => {
    return TrackProAPI.post('/assets/replacement-parts', partData)
}

const downloadAssetAttachment = (params: DownloadParamsType) => {
    const { asset_id, file_path } = params
    const endpoint =
        '/assets/download-attachment?asset_id=' +
        asset_id +
        '&file_path=' +
        file_path
    return TrackProAPI.get(endpoint, { responseType: 'blob' })
}

const getLocationHistory = (params: any) => {
    const endpoint = '/assets/location-history'
    return TrackProAPI.get(endpoint, { params })
}

const deleteReplacementPart = async (params: any) => {
    const endpoint = '/assets/replacement-parts'
    const { data } = await TrackProAPI.delete(endpoint, {
        data: { part_id: params },
    })
    return data
}

const editReplacementPart = async (params: EditPartType) => {
    const { part_id, pmid, part_number, type, quantity, notes, description } =
        params
    const endpoint = '/assets/replacement-parts'
    const { data } = await TrackProAPI.put(endpoint, {
        part_id,
        pmid,
        part_number,
        type,
        quantity,
        notes,
        description,
    })
    return data
}

const downloadDocs = async (document_id: number) => {
    const endpoint = `/assets/download-document?document_id=${document_id}`
    const { data } = await TrackProAPI.get(endpoint, { responseType: 'blob' })
    return data
}

const transferAsset = async(asset_id: any, email: string) => {
    const endpoint = '/assets/transfer'
    const { data } = await TrackProAPI.post(endpoint, { asset_id, email })
    return data
}

export default {
    getAssetList,
    updateAsset,
    addNonEscoPart,
    downloadAssetAttachment,
    getLocationHistory,
    deleteReplacementPart,
    editReplacementPart,
    getSingleAsset,
    downloadDocs,
    transferAsset
}
